"use client";

import { useState } from "react";
import ScrollReveal from "../common/ScrollReveal";
import ExpandCollapseCard from "../common/ExpandCollapseCard";
import QSuiteAnimation from "../common/QSuiteAnimation";
import { qSuitePacks } from "../Products/accordionContent";

export default function QSuite() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="relative w-full bg-background px-4 sm:px-6 lg:px-8 pt-12 sm:pt-16 md:pt-[70px] overflow-hidden">
      <div className="max-w-[1300px] mx-auto relative z-10">
        <ScrollReveal direction="up" delay={0}>
          <h2 className="text-white font-bold text-[32px] md:text-[44px] lg:text-[55px] leading-[1.2] lg:leading-[79px] text-center mb-5">
            <span className="relative inline-block">ECQ Q-SUITE</span>
          </h2>
        </ScrollReveal>

        {/* Approved copy, verbatim. Two tiers rather than the two equal lines
            the old block had, because these two are different things: a claim
            line and a paragraph explaining it.

            The claim line is 18px at medium, on request. It is spelled out
            rather than given a utility class because the system has no 18/500
            step: headline-4 is the only 18px token and it is 18px only below md
            (20px above it) and at weight 600. The 26px line height and 0.15px
            tracking are that token's own 18px values, so the numbers still come
            from theme.css rather than being picked here. It sits on
            text-highlight, so it reads as the claim.

            The paragraph keeps this section's responsive body step (14/20 to
            16/28) on text-default, which is the colour Hackgrid.tsx and
            Shred.tsx give their intro copy.

            The paragraph is held to 640px while the block around it stays at
            1078px: at 1078 this sentence sets ~130 characters to the line, and
            640 is what Hackgrid.tsx already uses for its long centred sentence.
            The short claim line above still gets the full width. */}
        <ScrollReveal direction="up" delay={100}>
          <div className="text-center max-w-[1078px] mx-auto mb-5">
            <p className="text-[18px] font-medium leading-[26px] tracking-[0.15px] text-text-highlight">
              Know What Attackers Can Actually Exploit
            </p>
            <p className="mx-auto mt-3 max-w-[640px] text-[14px] leading-[20px] tracking-[0.25px] md:text-[16px] md:leading-[28px] md:tracking-[0.5px] text-text-default">
              Nearly 3,000 private exploit intelligence records across enterprise IT, OT/ICS, and
              IoT, helping organizations verify what is exploitable, understand attack paths, and
              test whether defenses actually work.
            </p>
          </div>
        </ScrollReveal>

        <div className="flex flex-col lg:flex-row items-center justify-between gap-10 lg:gap-16">
          <ScrollReveal direction="left" delay={200} className="w-full max-w-[510px] shrink-0">
            <div className="relative mx-auto w-full">
              <QSuiteAnimation className="home-float relative w-full aspect-[638/436]" />
            </div>
          </ScrollReveal>

          <ScrollReveal
            direction="right"
            delay={300}
            className="flex-1 w-full min-w-0 lg:max-w-[570px]"
          >
            <div className="flex flex-col gap-4">
              {qSuitePacks.map((pack, index) => (
                <ExpandCollapseCard
                  key={pack.title}
                  title={pack.title}
                  headline={pack.headline}
                  description={pack.description}
                  isOpen={openIndex === index}
                  onToggle={() => setOpenIndex(openIndex === index ? null : index)}
                />
              ))}
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
